import { Params, Router } from '@angular/router';

import { RoutePaths } from '../shared/constants/route-paths.constant';
import { WorkloadQueryParameter } from '../shared/constants/workload-query-parameter.enum';
import { CapabilitiesService } from '../shared/shared-context/capabilities.service';

export abstract class BaseRouteGuard {
    constructor(
        protected readonly router: Router,
        protected readonly capabilitiesService: CapabilitiesService
    ) {
    }

    protected checkEnabledAndRedirect(
        enabled: boolean,
        redirect?: string,
        queryParams?: Params,
        forceNavigation?: boolean
    ): boolean {
        if (!enabled && (forceNavigation ?? !this.router.navigated)) {
            this.router.navigate([redirect ?? this.getDefaultRedirect()], queryParams ?  { queryParams } : {});
        }
        return enabled;
    }

    private getDefaultRedirect(): string {
        const workload = this.capabilitiesService.getWorkload();
        switch (workload) {
            case WorkloadQueryParameter.Embed:
                return `${RoutePaths.Embed}/${RoutePaths.OfficeHomeFallback}`;
            default:
                return RoutePaths.OfficeHomeFallback;
        }
    }
}
